/**
 * Explains why a school may be missing from the map: schools are not
 * seeded from a roster, they appear only once someone submits a gem for
 * one. Sits directly above the privacy statement in the same accordion
 * group, so it renders the bare <details> item and leaves the
 * `.nsw-accordion` wrapper to IntroContent.
 */
const FindYourSchool = () => (
  <details className="nsw-accordion__item" id="find-your-school">
    <summary className="nsw-accordion__title">
      Can’t find your school on the Map?
    </summary>
    <div className="nsw-accordion__content-wrap" id="find-your-school-panel">
      <div className="nsw-accordion__content">
        <p>Schools are not automatically added to the Map.</p>
        <p>
          Schools only appear and become searchable on the Map after a gem has
          been submitted for the school.
        </p>
        <p>
          To submit a gem and add your school to the Map, click the ‘Message’
          button below.
        </p>
      </div>
    </div>
  </details>
);

export default FindYourSchool;
